import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthProvider';

// Navigation avec liens conditionnels selon l'état d'authentification
function Navigation() {
    const { isLoggedIn, isAdmin } = useAuth();

    return (
        <div className="flex gap-6">
            <Link to="/" className="text-gray-400 hover:text-white">Home</Link>
            <Link to="/blogs" className="text-gray-400 hover:text-white">Blog</Link>
            <Link to="/projects" className="text-gray-400 hover:text-white">Projects</Link>
            <Link to="/about" className="text-gray-400 hover:text-white">About</Link>
            <Link to="/contact" className="text-gray-400 hover:text-white">Contact</Link>
            {isLoggedIn ? (
                <>
                    <Link to="/profile" className="text-gray-400 hover:text-white">Profile</Link>
                    {isAdmin && <Link to="/admin-dash" className="text-red-400 hover:text-red-300">Admin</Link>}
                </>
            ) : (
                <>
                    <Link to="/login" className="text-gray-400 hover:text-white">Login</Link>
                    <Link to="/create-account" className="text-gray-400 hover:text-white">Sign Up</Link>
                </>
            )}
        </div>
    );
}

export default Navigation;